<template>
  <div class="customer-edit">
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="fullPage"
    >
    </loading>
    <div class="container-fluid">
      <div class="col-12 overflow-auto">
        <div
          v-show="breakOrder"
          class="row bg-dark p-4"
          style="text-align: center; margin: auto; float: right"
        >
          <H2>{{ $t("customer.break") }}</H2>
        </div>
        <div
          v-show="!allowOrder"
          class="row bg-danger p-4"
          style="text-align: center; margin: auto; float: right"
        >
          <button
            v-show="!allowOrder"
            class="btn btn-danger btn-xs-block float-right"
            @click="unlockOrder(`${currentCustomer.cardCode}`)"
          >
            {{ $t("buttons.unlockAccount") }}
          </button>
        </div>
        <h5 class="text-muted mr-auto p-2 float-left">
          <strong> {{ $t("customer.index") }}</strong>
          <h2>
            {{ currentCustomer.cardCode }} - {{ currentCustomer.company }}
          </h2>
        </h5>
        <div v-show="allowOrder" class="p-2 col-12">
          <router-link
            class="btn btn-theme-add btn-xs-block float-right"
            to="/products"
            @click.native="handleSelectTypeOrder('salesOrder', 'new')"
          >
            {{ $t("buttons.createOrder") }}
          </router-link>
        </div>
      </div>
      <hr />
      <div class="container-fluid">
        <ul class="nav nav-tabs nav-pills">
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active: isActive('account') }"
              href="#account"
              @click.prevent="setActive('account')"
            >
              {{ $t("buttons.account") }}</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active: isActive('addresses') }"
              href="#addresses"
              @click.prevent="setActive('addresses')"
              >{{ $t("buttons.addresses") }}</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active: isActive('invoices') }"
              href="#invoices"
              @click.prevent="setActive('invoices')"
              @click="filterInvoiceList()"
              >{{ $t("buttons.invoices") }}</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{ active: isActive('orders') }"
              href="#orders"
              @click.prevent="setActive('orders')"
              @click="filterOrdersList()"
              >{{ $t("buttons.salesOrders") }}</a
            >
          </li>
        </ul>
        <div id="myTabContent" class="tab-content">
          <div
            id="account"
            class="tab-pane fade row"
            :class="{ 'active show': isActive('account') }"
          >
            <div class="container-fluid">
              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="card text-black mb-3">
                    <div class="card-header">
                      {{ $t("customer.information") }}
                    </div>
                    <div class="card-body">
                      <div class="row inline">
                        <label
                          for="cardCode"
                          class="col-form-label col-12 col-sm-4 col-xl-3"
                        >
                          {{ $t("customer.cardCode") }}</label
                        >
                        <div class="card-text col-sm-8">
                          <input
                            id="cardCode"
                            type="text"
                            readonly
                            class="form-control-plaintext"
                            :value="currentCustomer.cardCode"
                          />
                        </div>
                      </div>
                      <div class="row inline">
                        <label
                          for="company"
                          class="col-form-label col-12 col-sm-4 col-xl-3"
                          >{{ $t("customer.company") }}</label
                        >
                        <div class="card-text col-sm-8">
                          <input
                            id="company"
                            type="text"
                            readonly
                            class="form-control-plaintext"
                            :value="currentCustomer.company"
                          />
                        </div>
                      </div>
                      <div class="row inline">
                        <label
                          for="vat"
                          class="col-form-label col-12 col-sm-4 col-xl-3"
                          >{{ $t("customer.vatNumber") }}</label
                        >
                        <div class="card-text col-sm-8">
                          <input
                            id="vat"
                            type="text"
                            disabled="disabled"
                            class="form-control-plaintext"
                            :value="currentCustomer.vat"
                          />
                        </div>
                      </div>
                      <div class="row inline">
                        <label
                          for="email"
                          class="col-form-label col-12 col-sm-4 col-xl-3"
                        >
                          {{ $t("customer.email.index") }}</label
                        >
                        <div class="card-text col-sm-8">
                          <input
                            id="email"
                            type="text"
                            readonly
                            class="form-control-plaintext"
                            :value="currentCustomer.email"
                          />
                        </div>
                      </div>
                      <div style="display: none" class="row inline">
                        <label
                          for="key"
                          class="col-form-label col-12 col-sm-4 col-xl-3"
                        >
                          {{ $t("customer.salesManger") }}</label
                        >
                        <div class="card-text col-sm-8">
                          <input
                            id="key"
                            type="text"
                            readonly
                            class="form-control-plaintext"
                            :value="currentCustomer.salesRepresentative"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="card text-black mb-3">
                    <div class="card-header">
                      {{ $t("customer.billingAddress") }}
                    </div>
                    <div
                      v-if="currentCustomer && currentCustomer.billing"
                      class="card-body"
                    >
                      <div class="row inline">
                        <label
                          for="addressNameBilling"
                          class="col-form-label col-12 col-sm-4 col-xl-3"
                        >
                          {{ $t("customer.addressName") }}</label
                        >
                        <div class="card-text col-sm-8">
                          <input
                            id="addressNameBilling"
                            type="text"
                            readonly
                            class="form-control-plaintext"
                            placeholder="np. Oddział Warszawa - Bielany"
                            :value="currentCustomer.billing[0]['company']"
                          />
                        </div>
                      </div>
                      <div class="row inline">
                        <label
                          for="cityBilling"
                          class="col-form-label col-12 col-sm-4 col-xl-3"
                        >
                          {{ $t("customer.city") }}</label
                        >
                        <div class="card-text col-sm-8">
                          <input
                            id="cityBilling"
                            type="text"
                            readonly
                            class="form-control-plaintext"
                            :value="currentCustomer.billing[0]['city']"
                          />
                        </div>
                      </div>
                      <div class="row inline">
                        <label
                          for="streetBilling"
                          class="col-form-label col-12 col-sm-4 col-xl-3"
                        >
                          {{ $t("customer.street") }}</label
                        >
                        <div class="card-text col-sm-8">
                          <input
                            id="streetBilling"
                            type="text"
                            readonly
                            class="form-control-plaintext"
                            :value="currentCustomer.billing[0]['street']"
                          />
                        </div>
                      </div>
                      <div class="row inline">
                        <label
                          for="postCodeBilling"
                          class="col-form-label col-12 col-sm-4 col-xl-3"
                        >
                          {{ $t("customer.postcode") }}</label
                        >
                        <div class="card-text col-sm-8">
                          <input
                            id="postCodeBilling"
                            type="text"
                            readonly
                            class="form-control-plaintext"
                            :value="currentCustomer.billing[0]['postcode']"
                          />
                        </div>
                      </div>
                      <div class="row inline">
                        <label
                          for="provinceBilling"
                          class="col-form-label col-12 col-sm-4 col-xl-3"
                        >
                          {{ $t("customer.province") }}</label
                        >
                        <div class="card-text col-sm-8">
                          <select
                            class="form-control-plaintext"
                            readonly
                            :required="true"
                          >
                            <option
                              id="provinceBilling"
                              v-for="province in provinceList"
                              v-bind:value="province.code"
                              v-bind:key="province.name"
                              :disabled="true"
                              :selected="
                                province.code ==
                                  currentCustomer.billing[0]['province']
                              "
                            >
                              {{ province.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="row inline">
                        <label
                          for="countryBilling"
                          class="col-form-label col-12 col-sm-4 col-xl-3"
                        >
                          {{ $t("customer.country") }}</label
                        >
                        <div class="card-text col-sm-8">
                          {{
                            countryDisplay(
                              currentCustomer.billing[0]["country"]
                            )
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-header">
                {{ $t("customer.customerPayment") }}
              </div>
              <div class="table-responsive">
                <table class="table table-bordered table-striped p-2">
                  <thead>
                    <tr>
                      <th scope="col">
                        {{ $t("customer.balancePayment") }}
                      </th>
                      <th scope="col">
                        {{ $t("customer.creditLimit") }}
                      </th>
                      <th scope="col">
                        {{ $t("customer.overduePayments") }}
                      </th>
                      <th scope="col">
                        {{ $t("customer.overdueLimit") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <!--                                    {{ getCustomerInfo()}}-->
                    <tr
                      v-for="cr in customerBalance"
                      :key="cr['docEntry']"
                      class="m-1 p-1 bg-light"
                    >
                      <td class="">
                        <h6>
                          {{ currencyDisplay(cr["balance"], false, true) }}
                        </h6>
                      </td>
                      <td class="">
                        <h6>
                          {{ currencyDisplay(cr["creditLimit"], false, true) }}
                        </h6>
                      </td>
                      <td>
                        <h6>
                          {{ currencyDisplay(cr["overdue"], false, true) }}
                        </h6>
                      </td>
                      <td>
                        <h6>
                          {{ currencyDisplay(cr["debt"], false, true) }}
                        </h6>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-header">
                {{ $t("customer.lastOrders") }}
              </div>
              <div class="">
                <div class="table-responsive">
                  <table class="table table-bordered table-striped p-2">
                    <thead>
                      <tr>
                        <th scope="col">
                          {{ $t("customer.orderNumber") }}
                        </th>
                        <th scope="col">
                          {{ $t("customer.createdDate") }}
                        </th>
                        <th scope="col">
                          {{ $t("customer.shippingAddress") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="co in currentCustomer.orders"
                        :key="co['orderId']"
                        class="m-1 p-1 bg-light"
                      >
                        <td class="">
                          <h6>
                            {{ co["status"] }}
                            <small>{{ $t("orders.sap") }}</small>
                            <br />
                            <small
                              >{{ co["orderNumber"] }}
                              {{ $t("orders.b2b") }}</small
                            >
                          </h6>
                        </td>
                        <td class="">
                          <h6>{{ co["createdAt"] }}</h6>
                        </td>
                        <td>
                          <h6>{{ co["company"] }}</h6>
                          <!-- <span
                            class="badge badge-pill badge-primary float-right"
                          >
                            <h6 class="m-0">
                              {{
                                currencyDisplay(co["grandTotal"], false, true)
                              }}
                            </h6>
                          </span> -->
                        </td>
                        <td colspan="3" class="text-center">
                          <button
                            class="btn btn-theme-info btn-sm text-center"
                            @click="showOrder(co)"
                          >
                            {{ $t("buttons.showOrder") }}
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div
            id="addresses"
            class="tab-pane fade"
            :class="{ 'active show': isActive('addresses') }"
          >
            <div class="container pl-0 pr-0">
              <div class="row">
                <div class="col-md-12 col-12">
                  <div style="background-color: dimgrey" class="m-3">
                    <multiselect
                      class="form-control-select textarea"
                      :placeholder="$t('buttons.selectAddress')"
                      :value="currentAddress"
                      :options="selectShippingOptions"
                      track-by="id"
                      label="name"
                      :searchable="true"
                      deselect-label=""
                      select-label=""
                      @input="updateValueAction($event)"
                    />
                  </div>
                  <validation-observer ref="v-observer">
                    <div class="container-fluid pl-0 pr-0">
                      <div class="row">
                        <div class="col-md-12">
                          <label for="city">
                            {{ $t("customer.addressName") }}
                          </label>
                          <div class="form-group col-md-6">
                            <validation-provider
                              v-slot="v"
                              slim
                              rules="required"
                              name="addressName"
                            >
                              <input
                                id="addressName"
                                v-model="currentAddress.addressName"
                                :placeholder="
                                  addNewMode ? $t('customer.addressName') : ''
                                "
                                :disabled="!addNewMode"
                                type="text"
                                class="form-control"
                                :class="{
                                  'is-invalid': v.errors.length,
                                }"
                                onkeydown="this.value = this.value.toUpperCase();"
                              />
                            </validation-provider>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <label for="city">
                            {{ $t("customer.city") }}
                          </label>
                          <div class="form-group col-md-6">
                            <validation-provider
                              v-slot="v"
                              slim
                              rules="required"
                            >
                              <input
                                id="city"
                                v-model="currentAddress.city"
                                :placeholder="
                                  addNewMode ? $t('customer.city') : ''
                                "
                                :disabled="cityInputDisabled"
                                type="text"
                                class="form-control"
                                :class="{
                                  'is-invalid': v.errors.length,
                                }"
                              />
                            </validation-provider>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <label for="street">
                            {{ $t("customer.street") }}
                          </label>
                          <div class="form-group col-md-6">
                            <validation-provider
                              v-slot="v"
                              slim
                              rules="required"
                            >
                              <input
                                id="street"
                                v-model="currentAddress.street"
                                :placeholder="
                                  addNewMode ? $t('customer.street') : ''
                                "
                                :disabled="streetInputDisabled"
                                type="text"
                                class="form-control"
                                :class="{
                                  'is-invalid': v.errors.length,
                                }"
                              />
                            </validation-provider>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <label for="postcode">
                            {{ $t("customer.postcode") }}
                          </label>
                          <div class="form-group col-md-6">
                            <validation-provider
                              v-slot="v"
                              slim
                              rules="required"
                            >
                              <input
                                id="postCode"
                                v-model="currentAddress.postcode"
                                :placeholder="
                                  addNewMode ? $t('customer.postcode') : ''
                                "
                                :disabled="postCodeInputDisabled"
                                type="text"
                                class="form-control"
                                :class="{
                                  'is-invalid': v.errors.length,
                                }"
                              />
                            </validation-provider>
                          </div>
                        </div>
                        <div style="display: none" class="col-md-12">
                          <label for="province">
                            {{ $t("customer.province") }}
                          </label>
                          <div class="form-group col-md-6">
                            <validation-provider v-slot="v" slim rules="">
                              <select
                                id="province"
                                :value="currentAddress.province"
                                :placeholder="
                                  addNewMode ? $t('customer.country') : ''
                                "
                                :disabled="streetInputDisabled"
                                type="text"
                                class="form-control"
                                :class="{
                                  'is-invalid': v.errors.length,
                                }"
                                @input="
                                  currentAddress.province = $event.target.value
                                "
                              >
                                <option
                                  v-for="(province, index) in provinceList"
                                  :key="index"
                                  :value="province.code"
                                >
                                  {{ province.name }}
                                </option>
                              </select>
                            </validation-provider>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <label for="street">
                            {{ $t("customer.country") }}
                          </label>
                          <div class="form-group col-md-6">
                            <validation-provider
                              v-slot="v"
                              slim
                              rules="required"
                            >
                              <select
                                id="countryId"
                                :value="currentAddress.country"
                                :placeholder="
                                  addNewMode ? $t('customer.country') : ''
                                "
                                :disabled="streetInputDisabled"
                                type="text"
                                class="form-control"
                                :class="{
                                  'is-invalid': v.errors.length,
                                }"
                                @input="
                                  currentAddress.country = $event.target.value
                                "
                              >
                                <option
                                  v-for="country in countryList"
                                  :key="country.code"
                                  :value="country.code"
                                >
                                  {{
                                    locale === "pl"
                                      ? country.namepl
                                      : country.nameen
                                  }}
                                </option>
                              </select>
                            </validation-provider>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <label for="phone">
                            {{ $t("customer.personPhone") }}
                          </label>
                          <div class="form-group col-md-6">
                            <validation-provider
                              v-slot="v"
                              slim
                              rules="required"
                              name="phone"
                            >
                              <input
                                id="phone"
                                v-model="currentAddress.phone"
                                :placeholder="
                                  addNewMode ? $t('customer.personPhone') : ''
                                "
                                :disabled="phoneInputDisabled"
                                type="text"
                                class="form-control"
                                :class="{
                                  'is-invalid': v.errors.length,
                                }"
                              />
                            </validation-provider>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <label for="emailAddress">
                            {{ $t("customer.email.index") }}
                          </label>
                          <div class="form-group col-md-6">
                            <validation-provider
                              v-slot="v"
                              slim
                              rules="email"
                              name="emailAddress"
                            >
                              <input
                                id="emailAddress"
                                v-model="currentAddress.email"
                                :placeholder="
                                  addNewMode ? $t('customer.email.index') : ''
                                "
                                :disabled="emailInputDisabled"
                                type="text"
                                class="form-control"
                                :class="{
                                  'is-invalid': v.errors.length,
                                }"
                              />
                            </validation-provider>
                          </div>
                        </div>
                        <div v-if="visibleGlobalRoad" class="col-md-12">
                          <label for="codeGrs">
                            {{ $t("customer.codeGrs") }}
                          </label>
                          <div class="form-group col-md-6">
                            <validation-provider
                              v-slot="v"
                              slim
                              rules="required"
                              name="codeGrs"
                            >
                              <input
                                id="codeGrs"
                                v-model="currentAddress.codeGrs"
                                :placeholder="
                                  addNewMode ? $t('customer.codeGrs') : ''
                                "
                                :disabled="codeGrsInputDisabled"
                                type="text"
                                class="form-control"
                                :class="{
                                  'is-invalid': v.errors.length,
                                }"
                              />
                            </validation-provider>
                          </div>
                        </div>
                        <div v-if="visibleGlobalRoad" class="col-md-12">
                          <label for="nameGrs">
                            {{ $t("customer.nameGrs") }}
                          </label>
                          <div class="form-group col-md-6">
                            <validation-provider
                              v-slot="v"
                              slim
                              rules="required"
                              name="nameGrs"
                            >
                              <input
                                id="nameGrs"
                                v-model="currentAddress.nameGrs"
                                :placeholder="
                                  addNewMode ? $t('customer.nameGrs') : ''
                                "
                                :disabled="nameGrsInputDisabled"
                                type="text"
                                class="form-control"
                                :class="{
                                  'is-invalid': v.errors.length,
                                }"
                              />
                            </validation-provider>
                          </div>
                        </div>
                      </div>
                    </div>
                  </validation-observer>
                </div>
              </div>
            </div>
          </div>
          <div
            id="invoices"
            class="tab-pane fade"
            :class="{ 'active show': isActive('invoices') }"
          >
            <div v-show="displayInvoicePdf" id="viewInvoice">
              <button class="btn-dark" @click="hideInvoicePdf()" />
              <embed
                id="generatePdfInvoice"
                class="pdfInvoice"
                :src="invoiceSrc"
                width="100%"
                height="600px"
              />
            </div>

            <div class="col-md-12 pl-0 pr-0">
              <div class="col-sm-6 col-12 m-2">
                <validation-observer ref="v-observer-invoice">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <label
                        class="input-group-text"
                        for="filterInvoiceBegin"
                        >{{ $t("customer.filterBegin") }}</label
                      >
                    </div>
                    <validation-provider v-slot="v" slim rules="required">
                      <input
                        id="filterInvoiceBegin"
                        v-model="filterInvoicesBegin"
                        type="date"
                        name="filterInvoicesBegin"
                        class="form-control"
                        :class="{
                          'is-invalid': v.errors.length,
                        }"
                      />
                    </validation-provider>
                    <validation-provider v-slot="v" slim rules="required">
                      <input
                        v-model="filterInvoicesEnd"
                        id="filterInvoicesEnd"
                        type="date"
                        name="filterInvoiceEnd"
                        class="form-control"
                        :class="{
                          'is-invalid': v.errors.length,
                        }"
                      />
                    </validation-provider>
                    <button
                      class="btn btn-secondary"
                      @click="filterInvoiceList"
                    >
                      {{ $t("buttons.filter") }}
                    </button>
                  </div>
                </validation-observer>
              </div>
              <div class="table-responsive">
                <table
                  id="invoicesTable"
                  class="table table-striped table-bordered"
                  style="width: 100%"
                >
                  <thead>
                    <tr>
                      <th>{{ $t("customer.documentNumber") }}</th>
                      <th>{{ $t("customer.docDate") }}</th>
                      <th>{{ $t("customer.status") }}</th>
                      <th>{{ $t("basket.grossAmount") }}</th>
                      <th>PDF</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="i in invoiceReports"
                      :key="i['docEntry']"
                      class="m-1 p-1 bg-light"
                    >
                      <td>{{ i["docNum"] }}</td>
                      <td>{{ i["docDate"] }}</td>
                      <td>{{ i["status"] }}</td>
                      <td>
                        {{ parseFloat(i["gross"]).toFixed(2) }}
                        {{ i["currency"] }}
                      </td>
                      <td>
                        <button
                          :value="i['docEntry']"
                          @click="getInvoicePdf(i)"
                        >
                          PDF
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div
            id="orders"
            class="tab-pane fade"
            :class="{ 'active show': isActive('orders') }"
          >
            <div v-show="displayOrderPdf" id="viewOrder">
              <button width="100%" class="btn-dark" @click="hideOrderPdf()" />
              <embed
                id="generatePdfOrder"
                class="pdfInvoice"
                :src="orderSrc"
                width="100%"
                height="600px"
              />
            </div>
            <div class="col-md-12 pl-0 pr-0">
              <div class="col-sm-6 col-12 m-2">
                <validation-observer ref="v-observer-sales">
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <label class="input-group-text" for="filterOrdersBegin">{{
                        $t("customer.filterBegin")
                      }}</label>
                    </div>
                    <validation-provider v-slot="v" slim rules="required">
                      <input
                        id="filterOrdersBegin"
                        v-model="filterOrdersBegin"
                        type="date"
                        name="filterOrdersBegin"
                        class="form-control"
                        :class="{
                          'is-invalid': v.errors.length,
                        }"
                      />
                    </validation-provider>
                    <validation-provider v-slot="v" slim rules="required">
                      <input
                        id="filterOrdersEnd"
                        v-model="filterOrdersEnd"
                        type="date"
                        name="filterOrdersEnd"
                        class="form-control"
                        :class="{
                          'is-invalid': v.errors.length,
                        }"
                      />
                    </validation-provider>
                    <button class="btn btn-secondary" @click="filterOrdersList">
                      {{ $t("buttons.filter") }}
                    </button>
                  </div>
                </validation-observer>
              </div>
              <div class="table-responsive">
                <table
                  id="ordersTable"
                  class="table table-striped table-bordered"
                  style="width: 100%"
                >
                  <thead>
                    <tr>
                      <th>{{ $t("customer.documentNumber") }}</th>
                      <th>{{ $t("customer.docDate") }}</th>
                      <th>{{ $t("customer.status") }}</th>
                      <th>{{ $t("basket.grossAmount") }}</th>
                      <th scope="col">
                        {{ $t("orders.trackingNumber") }}
                      </th>
                      <th scope="col">
                        {{ $t("orders.carrierStatus") }}
                      </th>
                      <th>PDF</th>
                      <!-- <th>{{ $t("customer.generateInvoiceWIthTransport") }}</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="o in ordersReports"
                      :key="o['docEntry']"
                      class="m-1 p-1 bg-light"
                    >
                      <td>{{ o["docNum"] }}</td>
                      <td>{{ o["docDate"] }}</td>
                      <td>{{ o["status"] }}</td>
                      <td>
                        {{ parseFloat(o["gross"]).toFixed(2) }}
                        {{ o["currency"] }}
                      </td>
                      <td>
                        <a
                          v-if="
                            o.docEntryDocument == 'FEDEX' ||
                              o.docEntryDocument == 'UPS'
                          "
                          :href="generateLinkByCarrier(o)"
                          target="_blank"
                          rel="noreferrer"
                        >
                          {{ o.creditLimit }}
                        </a>
                        <span v-else>{{ o.creditLimit }}</span>
                      </td>
                      <td>
                        {{ getStatusCarrier(o.saldoServices) }} :
                        {{ o.docEntryDocument }}
                      </td>
                      <td>
                        <button :value="o['docEntry']" @click="getOrderPdf(o)">
                          PDF
                        </button>
                      </td>
                      <!-- <td v-if="o['debt'] === 'Y'">
                        <button class="btn btn-dark" @click="createInvoice(o)">
                          {{ $t("customer.generateInvoiceWIthTransport") }}
                        </button>
                      </td>
                      <td v-else-if="o['base64'] === 'Y'">
                        <button
                          class="btn btn-dark"
                          @click="createInvoiceFromEtoll(o)"
                        >
                          {{ $t("customer.generateInvoiceWIthTransport") }}
                        </button>
                      </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <historic-order-modal
      :visible="isOrderModalVisible"
      :order="showedOrder"
      @on-close="isOrderModalVisible = !isOrderModalVisible"
      @on-confirm="reorder($event)"
    />
  </div>
</template>
<script>
import Vue from "vue";
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import * as ServiceReport from "../services/reports";
import * as ServiceOrder from "../services/orders";
import Multiselect from "vue-multiselect";
import { currencyMixin } from "../mixins";
import { CountryListGus } from "../enums/CountriesAll";
import { StateList } from "../enums/State";
import HistoricOrderModal from "./HistoricOrderModal";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import i18n from "../translations";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Countries from "../enums/CountriesEuropeanUnion";
import { StatusCarrier } from "../enums/ReportDictionary";

export default {
  name: "CustomerDetails",
  components: {
    Multiselect,
    HistoricOrderModal,
    ValidationObserver,
    ValidationProvider,
    Loading,
  },
  filters: {
    currency(value) {
      return new Intl.NumberFormat("pl-PL", {
        style: "currency",
        currency: "PLN",
      }).format(value);
    },
  },
  mixins: [currencyMixin],
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data: function() {
    return {
      isLoading: false,
      fullPage: true,
      visibleGlobalRoad: false,
      locale: i18n.locale,
      countryList: CountryListGus,
      filterInvoicesEnd: "",
      filterInvoicesBegin: "",
      filterOrdersBegin: "",
      filterOrdersEnd: "",
      provinceList: StateList,
      activeItem: "account",
      invoiceReports: [],
      ordersReports: [],
      customerBalance: [],
      allowOrder: true,
      breakOrder: false,
      displayOrderPdf: false,
      displayInvoicePdf: false,
      saveAddressForm: false,
      currentCustomer: [],
      currentBilling: [],
      cardCode: "",
      currentAddress: [],
      cityInputDisabled: true,
      streetInputDisabled: true,
      postCodeInputDisabled: true,
      phoneInputDisabled: true,
      codeGrsInputDisabled: true,
      nameGrsInputDisabled: true,
      emailInputDisabled: true,
      addNewMode: false,
      invoiceSrc: "",
      orderSrc: "",
      showedOrder: null,
      isOrderModalVisible: false,
      selectShippingOptions: [],
      validVat: true,
      carrierList: StatusCarrier,
      specialCardCode: ["O00004", "O00005", "O00009"],
    };
  },
  computed: {
    ...mapState("customers", ["customer"]),
    ...mapGetters("auth", ["user", "language"]),
    // ...mapGetters("cart", ["language"]),
    ...mapGetters("currency", ["currentCurrency"]),
    ...mapState("products", ["products"]),
    ...mapGetters("customers", ["billing"]),
  },
  watch: {
    customer(newValue) {
      this.currentCustomer = newValue;
      this.visibleGlobalRoad = this.specialCardCode.includes(newValue.cardCode)
        ? true
        : false;
      this.getCustomerBalance(newValue.cardCode).then(this.waitUntilVat());
      this.selectShippingOptions = !this.specialCardCode.includes(
        newValue.cardCode
      )
        ? this.currentCustomer.shipping.map((shipObject) => ({
            name:
              shipObject.addressName +
              " - " +
              shipObject.city +
              " - " +
              shipObject.street,
            id: shipObject.addressId,
          }))
        : this.currentCustomer.shipping.map((shipObject) => ({
            name:
              shipObject.addressName +
              " - " +
              shipObject.city +
              " - " +
              shipObject.street +
              " - " +
              shipObject.codeGrs +
              " - " +
              shipObject.nameGrs,
            id: shipObject.addressId,
          }));
    },
    billing(newValue) {
      this.currentBilling = newValue;
    },
  },
  mounted() {
    this.getCurrentCustomer();
    this.filterInvoicesEnd = new Date().toISOString().slice(0, 10);
    this.filterInvoicesBegin = new Date(
      new Date().setDate(new Date().getDate() - 30)
    )
      .toISOString()
      .slice(0, 10);
    this.filterOrdersEnd = new Date().toISOString().slice(0, 10);
    this.filterOrdersBegin = new Date(
      new Date().setDate(new Date().getDate() - 30)
    )
      .toISOString()
      .slice(0, 10);
  },
  methods: {
    ...mapMutations("cart", ["selectOrderType", "selectOrderStatus"]),
    ...mapMutations("currency", ["setCurrency"]),
    ...mapActions("cart", ["addProduct", "addReorder"]),
    ...mapActions("products", ["getProductsToCardCode"]),
    ...mapActions("customers", [
      "updateCustomerShipping",
      "addCustomerShipping",
      "getCurrentCustomer",
    ]),
    getStatusCarrier: function(e) {
      var result = this.carrierList.find((item) => item.value === e);
      return result ? result.name : "-";
    },
    generateLinkByCarrier(o) {
      let nr = o.creditLimit;
      let urlTrack = "#";
      switch (o.docEntryDocument) {
        case "UPS":
          urlTrack = `https://www.ups.com/track?loc=pl_PL&requester=QUIC&tracknum=${nr}`;
          break;
        case "FEDEX":
          if (o.balance == "PL")
            urlTrack = `https://www.fedex.com/pl-pl/online/domestic-tracking.html#/preview?packages=${nr}&trackingKey=${nr}`;
          else urlTrack = `https://www.fedex.com/fedextrack/?trknbr=${nr}`;
          break;
        default:
          urlTrack;
          break;
      }
      return urlTrack;
    },
    filterOrdersList: function(e) {
      this.$refs["v-observer-sales"].validate().then(async (result) => {
        if (result) {
          this.getOrdersReports(this.currentCustomer.cardCode);
        }
      });
    },
    filterInvoiceList: function(e) {
      this.$refs["v-observer-invoice"].validate().then(async (result) => {
        if (result) {
          this.getInvoiceReport(this.currentCustomer.cardCode);
        }
      });
    },
    updateValueAction(value) {
      const addressData = this.customer.shipping.find(
        (shipObject) => shipObject.addressId === value.id
      );
      // We do a clone to avoid mutation outside vuex
      if (addressData) {
        this.currentAddress = {
          ...addressData,
        };
      }
    },
    nameShippingAddress({ addressName, street }) {
      return `${addressName} — [${street}]`;
    },
    nameShippingAddressGrs({ addressName, street }) {
      return `${addressName} — [${street}]`;
    },
    handleSelectCustomerAddress(shipping) {
      this.$store.commit("cart/selectCustomer", shipping);
      this.$store.commit("cart/setCartData", []);
      localStorage.removeItem("cart");
    },
    handleSelectTypeOrder(type, status) {
      this.selectOrderType(type);
      this.selectOrderStatus(status);
      // this.$router.push("/order");
    },
    hideInvoicePdf() {
      this.displayInvoicePdf = false;
    },
    hideOrderPdf() {
      this.displayOrderPdf = false;
    },
    handleRedirectToCart() {
      this.$router.push("/cart");
    },
    isActive(menuItem) {
      return this.activeItem === menuItem;
    },
    setActive(menuItem) {
      this.activeItem = menuItem;
    },
    waitUntilVat: function(e) {
      // currencyMixin.methods.validationVIES(this.currentCustomer);
      // currencyMixin.methods.validationGUS(this.currentCustomer);
      // this.getViesINFO();
    },
    async getInvoicePdf(invoice) {
      this.isLoading = true;
      let response = await ServiceReport.getInvoicePdf(invoice, this.language);
      this.isLoading = false;
      if (response.data) {
        var base64 = response.data.customerFormSubmit.allReports;
        let pdfWindow = window.open("about:blank");
        pdfWindow.document.write(
          "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
            encodeURI(base64[0].message) +
            "'></iframe>"
        );
      } else {
        console.log(response);
      }
    },
    async getOrderPdf(order) {
      this.isLoading = true;
      let response = await ServiceReport.getOrderPdf(order, this.language);
      this.isLoading = false;
      if (response.data) {
        var base64 = response.data.customerFormSubmit.allReports;
        let pdfWindow = window.open("about:blank");
        pdfWindow.document.write(
          "<iframe width='100%' height='100%' src='data:application/pdf;base64," +
            encodeURI(base64[0].message) +
            "'></iframe>"
        );
      } else {
        console.log(response);
      }
    },
    async getViesINFO() {
      if (
        Countries.includes(
          this.currentCustomer.vat.substring(0, 2).toUpperCase()
        )
      ) {
        this.isLoading = true;
        let response = await ServiceReport.getViesInformation(
          this.currentCustomer.vat
        );
        if (response.data) {
          if (
            response.data.customerFormSubmit.allReports[0].message == "false"
          ) {
            // this.allowOrder = false;
            Vue.alert(
              "Kontrahent nieznaleziony w VIES lub serwis jest niedostępny, zweryfikuj kontrahenta samodzielnie",
              "Błąd kontrahenta",
              "error"
            );
          }
        } else {
          console.log(response);
        }
        this.isLoading = false;
      }
    },
    async getInvoiceReport(cardCode) {
      this.isLoading = true;
      let response = await ServiceReport.getInvoicesByCustomer(
        cardCode,
        this.filterInvoicesBegin,
        this.filterInvoicesEnd,
        this.user.ownerCode
      );
      this.isLoading = false;
      if (response.data) {
        this.invoiceReports = response.data.customerFormSubmit.allReports;
      } else {
        console.log(response);
      }
    },
    async getOrdersReports(cardCode) {
      this.isLoading = true;
      let response = await ServiceReport.getOrdersByCustomer(
        cardCode,
        this.filterOrdersBegin,
        this.filterOrdersEnd,
        this.user.ownerCode
      );
      this.isLoading = false;
      if (response.data) {
        this.ordersReports = response.data.customerFormSubmit.allReports;
      } else {
        console.log(response);
      }
    },
    async getCustomerBalance(cardCode) {
      this.isLoading = true;
      let response = await ServiceReport.getBalanceByCustomer(cardCode);
      this.isLoading = false;
      if (response.data) {
        this.customerBalance = response.data.customerFormSubmit.allReports;
        let balance = parseInt(this.customerBalance[0].overdue);
        let balanceLimit = parseInt(this.customerBalance[0].debt);
        if (cardCode === "O00004") {
          this.allowOrder = true;
        } else {
          let balanceLimits = balanceLimit - balance;
          this.allowOrder = balanceLimits > 0 ? true : false;
        }
      } else {
        console.log(response);
      }
      return [];
    },
    async unlockOrder(cardCode) {
      this.isLoading = true;
      let response = await ServiceReport.getUnlockedCustomer(cardCode);
      this.isLoading = false;
      if (response.data) {
        this.allowOrder =
          response.data.customerFormSubmit.allReports[0].message == "false";
      } else {
        console.log(response);
      }
      return [];
    },
    openAddressEditForm() {
      this.addNewMode = false;
      this.saveAddressForm = true;
      this.streetInputDisabled = false;
      this.postCodeInputDisabled = false;
      this.cityInputDisabled = false;
      this.phoneInputDisabled = false;
      this.codeGrsInputDisabled = false;
      this.nameGrsInputDisabled = false;
      this.emailInputDisabled = false;
    },
    openAddNewForm() {
      this.addNewMode = true;
      this.saveAddressForm = true;
      this.streetInputDisabled = false;
      this.postCodeInputDisabled = false;
      this.cityInputDisabled = false;
      this.codeGrsInputDisabled = false;
      this.nameGrsInputDisabled = false;
      this.emailInputDisabled = false;
      this.currentAddress = {};
      this.phoneInputDisabled = false;
      this.$set(this.currentAddress, "city", "");
      this.$set(this.currentAddress, "street", "");
      this.$set(this.currentAddress, "postcode", "");
      this.$set(this.currentAddress, "addressName", "");
      this.$set(this.currentAddress, "phone", "");
      this.$set(this.currentAddress, "codeGrs", "");
      this.$set(this.currentAddress, "nameGrs", "");
      this.$set(this.currentAddress, "emailAddress", "");
    },
    async saveAddressEditForm() {
      this.$refs["v-observer"].validate().then(async (result) => {
        if (result) {
          this.isLoading = true;
          let response = await this.updateCustomerShipping(this.currentAddress);
          this.isLoading = false;
          this.addNewMode = false;
          this.saveAddressForm = false;
          this.streetInputDisabled = false;
          this.postCodeInputDisabled = false;
          this.cityInputDisabled = false;
          this.phoneInputDisabled = false;
          this.emailInputDisabled = false;
        }
      });
    },
    async saveAddressAddForm() {
      this.$refs["v-observer"].validate().then(async (result) => {
        if (result) {
          if (this.currentCustomer.shipping) {
            let sameNameShipping = this.currentCustomer.shipping.find(
              (shipping) =>
                shipping.addressName === this.currentAddress.addressName
            );
            if (sameNameShipping) {
              this.$refs["v-observer"].setErrors({
                addressName: [this.$t("customer.errors.shippingAddressName")],
              });
              return;
            }
          }
          this.isLoading = true;
          let response = await this.addCustomerShipping(this.currentAddress);
          this.isLoading = false;
          this.currentAddress = {
            ...this.currentCustomer.shipping[
              this.currentCustomer.shipping.length - 1
            ],
          };
          // this.openAddressEditForm();
        }
      });
    },
    showOrder(co) {
      this.showedOrder = co;
      this.isOrderModalVisible = true;
    },
    async reorder(historicOrder) {
      this.isLoading = true;
      let response = await ServiceOrder.getOrderInformation(
        "17",
        historicOrder.docEntry,
        this.user.ownerCode,
        ""
      );
      this.isLoading = false;
      if (response.data) {
        this.$store.commit("cart/setCartData", []);
        this.addReorder({
          reorder: response.data.documentFormCustomerFilter,
          type: "salesOrder",
          mode: "edit",
        });
        this.$router.push("/summary");
      } else {
        Vue.alert($t("customer.infoWrong"));
      }
    },
    async createInvoice(historicOrder) {
      this.$store.commit("cart/setCartData", []);
      this.isLoading = true;
      let response = await ServiceOrder.getOrderInformation(
        "13",
        historicOrder.docEntry,
        this.user.ownerCode,
        historicOrder.docDueDate
      );
      this.isLoading = false;
      if (response.data) {
        this.$store.commit("cart/setCartData", []);
        this.addReorder({
          reorder: response.data.documentFormFilter,
          type: "invoice",
          mode: "create",
        });
        this.$router.push("/summary");
      } else {
        Vue.alert($t("customer.infoWrong"));
      }
    },
    async createInvoiceFromEtoll(historicOrder) {
      this.$store.commit("cart/setCartData", []);
      this.isLoading = true;
      let response = await ServiceOrder.getOrderInformation(
        "19",
        historicOrder.docEntry,
        this.user.ownerCode,
        historicOrder.docDueDate
      );
      this.isLoading = false;
      if (response.data) {
        this.$store.commit("cart/setCartData", []);
        this.addReorder({
          reorder: response.data.documentFormFilter,
          type: "createInvoiceOrder",
          mode: "createInvoice",
        });
        this.$router.push("/summary");
      } else {
        Vue.alert($t("customer.infoWrong"));
      }
    },
  },
};
</script>
<style scoped>
.card-text > label {
  min-width: 100px;
}
.form-inline {
  border: solid 1px #ebebe4;
  padding: 5px;
}
</style>
